module.exports = "./img/22ad8cfaef0fb489dc06b79395846f87.jpg";